import { Flex } from 'antd';
import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Logotype } from '@entities';
import { useAccount } from '@hooks';
import { type MenuItem, filteredMenu } from '@utils';

import { menuBottom, menuList } from './menu';
import * as S from './styled';

// An external item leaves this app entirely (Pulse is its own portal behind the same realm), so it
// is an anchor opening a new tab rather than a NavLink — a router link would try to match the URL
// against this app's routes and land on Not found.
const renderItem = (item: MenuItem) =>
  item.external ? (
    <S.MenuExternalLink
      key={item.to}
      href={item.to}
      target="_blank"
      rel="noreferrer"
    >
      {item.icon}
      {item.name}
    </S.MenuExternalLink>
  ) : (
    <S.MenuLink key={item.to} to={item.to}>
      {item.icon}
      {item.name}
    </S.MenuLink>
  );

const Sidebar: FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { role } = useAccount();

  const filteredMenuList = filteredMenu(menuList, role);

  const filteredMenuBottomList = filteredMenu(menuBottom, role);

  useEffect(
    () => {
      if (pathname === '/') {
        navigate('/companies');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname]
  );

  return (
    <S.Sidebar width={105}>
      <Flex vertical>
        <Logotype />

        <S.Menu>{filteredMenuList.map(renderItem)}</S.Menu>
      </Flex>

      <S.Menu>{filteredMenuBottomList.map(renderItem)}</S.Menu>
    </S.Sidebar>
  );
};

export default Sidebar;
